import React from 'react';
import {Trans} from 'react-i18next';
import {Entry, TimelineEntry} from './Shared';

export const DocumentDownloadedTimelineEntry = ({entry}) => {
    return (
        <TimelineEntry entry={entry} status="complete" icon="download">
            <Entry.Title>
                <Trans
                    i18nKey="warehousing.timeline.DocumentDownloaded.title"
                    values={{name: entry.fileName}}
                    components={{
                        fileLink: <a href={entry.downloadUrl} target="_blank" rel="noopener noreferrer" download />,
                    }}
                />
            </Entry.Title>
        </TimelineEntry>
    );
};
